import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { BehaviorSubject, Observable, of, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenStorageService } from '@services/token-storage.service';
@Injectable({
  providedIn: 'root'
})
export class MailboxService {
  private unreadMailSubject = new BehaviorSubject<boolean>(false);
  unreadMail$ = this.unreadMailSubject.asObservable(); // 讓其他元件訂閱它
  constructor(private http: HttpClient) { }

  loadMails(): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/load_mails`, {}, { headers });
  }
  responceMail(apiUrl: string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}${apiUrl}`, {}, { headers });
  }
  viewMailDetails(mail_id:number | string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/view_mail_details/${mail_id}`, { mail_id }, { headers });
  }
  getUnreadMailCount(): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/unread_mails_count`, {  }, { headers });
  }
  updateUnreadMailStatus(status: boolean): void {
    this.unreadMailSubject.next(status); // 發送未讀狀態變更
  }

  /** 與通知中心相同：以 load_mails / load_team_mails 回傳的 status === 'send' 判定未讀。 */
  hasUnreadInMailList(data: { mail_List?: { status?: string }[] } | null | undefined): boolean {
    return (data?.mail_List || []).some((m) => m.status === 'send');
  }

  /** 個人 + 各團隊信箱合併未讀（與 NotificationCenter unified 模式一致）。 */
  getUnifiedUnreadStatus(teamCodes: string[]): Observable<boolean> {
    const codes = (teamCodes || []).filter(Boolean);
    const requests: Observable<unknown>[] = [this.loadMails(), ...codes.map((code) => this.loadTeamMails(code))];
    return forkJoin(requests).pipe(
      map((results) => results.some((data) => this.hasUnreadInMailList(data as { mail_List?: { status?: string }[] }))),
    );
  }

  private authHeaders(): HttpHeaders | null {
    const token = TokenStorageService.getToken();
    if (!token) return null;
    return new HttpHeaders().set('Authorization', `Bearer ${token}`);
  }

  markMailsRead(mailIds: number[]): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(
      `${environment.apiBaseUrl}/mailbox/mark_mails_read`,
      { mail_ids: mailIds },
      { headers },
    );
  }

  markAllMailsRead(): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/mark_all_read`, {}, { headers });
  }

  deleteMails(mailIds: number[]): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(
      `${environment.apiBaseUrl}/mailbox/delete_mails`,
      { mail_ids: mailIds },
      { headers },
    );
  }

  markTeamMailsRead(teamCode: string, mailIds: number[]): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(
      `${environment.apiBaseUrl}/mailbox/mark_team_mails_read`,
      { team_code: teamCode, mail_ids: mailIds },
      { headers },
    );
  }

  markAllTeamMailsRead(teamCode: string): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(
      `${environment.apiBaseUrl}/mailbox/mark_all_team_read`,
      { team_code: teamCode },
      { headers },
    );
  }

  deleteTeamMails(teamCode: string, mailIds: number[]): import('rxjs').Observable<any> {
    const headers = this.authHeaders();
    if (!headers) return of(null);
    return this.http.post(
      `${environment.apiBaseUrl}/mailbox/delete_team_mails`,
      { team_code: teamCode, mail_ids: mailIds },
      { headers },
    );
  }
  loadEnterpriseMails(taxId :string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/load_enterprise_mails`, {"taxId":taxId}, { headers });
  }
    viewEnterpriseMailDetails(taxId :string,mail_id:number | string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/view_enterprise_mail_details`, { "taxId":taxId,"mail_id":mail_id }, { headers });
  }
    loadTeamMails(team_code :string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/load_team_mails`, {"team_code":team_code}, { headers });
  }
    viewTeamMailDetails(team_code :string,mail_id:number | string): Observable<any> {
    const token = TokenStorageService.getToken();
    if (!token) {
      console.log('No token found in localStorage');
      return of(null);
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiBaseUrl}/mailbox/view_team_mail_details`, { "team_code":team_code,"mail_id":mail_id }, { headers });
  }
}
